module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-card', {
    staticClass: "box-card",
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', {
    staticStyle: {
      "border-bottom": "0"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("广告管理")])]), _vm._v(" "), _c('el-tabs', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "数据加载中..."
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "广告列表"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding": "20px 0px",
      "text-align": "left"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "topForm",
    attrs: {
      "inline": true,
      "model": _vm.topForm
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.add()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" 新增\n                        ")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "2%"
    },
    attrs: {
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "广告名称"
    },
    model: {
      value: (_vm.topForm.name),
      callback: function($$v) {
        _vm.$set(_vm.topForm, "name", $$v)
      },
      expression: "topForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "2%"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "search",
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        _vm.searchData()
      }
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-table', {
    ref: "table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "element-loading-text": "拼命加载中",
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "imgUrl",
      "label": "素材"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.imgUrl != '') ? _c('span', [_c('img', {
          staticClass: "avatar",
          attrs: {
            "src": _vm.fileHost + scope.row.imgUrl
          }
        }), _vm._v(" "), _c('a', [_vm._v(".jpg")])]) : _c('span', [(scope.row.videoUrl.split('.') == 'mp4') ? _c('video', {
          staticClass: "avatar",
          attrs: {
            "id": "video",
            "src": _vm.fileHost + scope.row.videoUrl
          }
        }, [_c('a', [_vm._v(".mp4")])]) : _c('img', {
          staticClass: "avatar",
          attrs: {
            "src": require("../../../assets/mp3.png")
          }
        })])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "advertiseName",
      "label": "广告名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "typeName",
      "label": "广告类型"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "广告位置"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.pageType == 'index') ? _c('div', [_vm._v("首页")]) : _vm._e(), _vm._v(" "), (scope.row.pageType == 'indexAudio') ? _c('div', [_vm._v("首页音频")]) : _vm._e(), _vm._v(" "), (scope.row.pageType == 'listAudio') ? _c('div', [_vm._v("商品列表页音频")]) : _vm._e(), _vm._v(" "), (scope.row.pageType == 'detailAudio') ? _c('div', [_vm._v("商品详情页音频")]) : _vm._e(), _vm._v(" "), (scope.row.pageType == 'payAudio') ? _c('div', [_vm._v("购买页音频")]) : _vm._e(), _vm._v(" "), (scope.row.pageType == 'qrAudio') ? _c('div', [_vm._v("扫码购买音频")]) : _vm._e(), _vm._v(" "), (scope.row.pageType == 'deliveryAudio') ? _c('div', [_vm._v("提货页音频")]) : _vm._e(), _vm._v(" "), (scope.row.pageType == 'takeawayAudio') ? _c('div', [_vm._v("外卖提货页音频")]) : _vm._e(), _vm._v(" "), (scope.row.pageType == 'vendingAudio') ? _c('div', [_vm._v("出货中音频")]) : _vm._e(), _vm._v(" "), (scope.row.pageType == 'successAudio') ? _c('div', [_vm._v("完成页音频")]) : _vm._e(), _vm._v(" "), (scope.row.pageType == 'vendoverAudio') ? _c('div', [_vm._v("下件取货音频")]) : _vm._e(), _vm._v(" "), (scope.row.pageType == 'failAudio') ? _c('div', [_vm._v("出货异常页音频")]) : _vm._e(), _vm._v(" "), (scope.row.pageType == 'button') ? _c('div', [_vm._v("首页双按钮-左")]) : _vm._e(), _vm._v(" "), (scope.row.pageType == 'buttonRight') ? _c('div', [_vm._v("首页双按钮-右")]) : _vm._e(), _vm._v(" "), (scope.row.pageType == 'buttonMiddle') ? _c('div', [_vm._v("首页单按钮-居中")]) : _vm._e(), _vm._v(" "), (scope.row.pageType == 'excode') ? _c('div', [_vm._v("提货页")]) : _vm._e(), _vm._v(" "), (scope.row.pageType == 'shipment') ? _c('div', [_vm._v("出货页")]) : _vm._e(), _vm._v(" "), (scope.row.pageType == 'vend') ? _c('div', [_vm._v("完成页")]) : _vm._e(), _vm._v(" "), (scope.row.pageType == 'vendFail') ? _c('div', [_vm._v("出货异常页")]) : _vm._e(), _vm._v(" "), (scope.row.pageType == 'float') ? _c('div', [_vm._v("首页悬浮按钮")]) : _vm._e(), _vm._v(" "), (scope.row.pageType == 'ThirdUrl') ? _c('div', [_vm._v("第三方页面")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "fodderSize",
      "label": "素材大小"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "updateTime",
      "label": "更新日期",
      "formatter": _vm.formatter
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "255px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              _vm.advertiseEdit(scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              _vm.unassignClient(scope.row)
            }
          }
        }, [_vm._v("发布")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              _vm.handleDelete(scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentpage,
      "page-count": _vm.pagesCount,
      "page-sizes": _vm.pagesizes,
      "page-size": _vm.pagesize,
      "total": _vm.pagesCount,
      "background": "",
      "layout": " total, prev, pager, next, jumper"
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-chahange": _vm.handleSizeChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "发布记录"
    }
  }, [_c('el-select', {
    staticClass: "m-1",
    attrs: {
      "placeholder": "分部"
    },
    on: {
      "change": function($event) {
        _vm.getPush()
      }
    },
    model: {
      value: (_vm.branchIndex),
      callback: function($$v) {
        _vm.branchIndex = $$v
      },
      expression: "branchIndex"
    }
  }, _vm._l((_vm.branchList), function(item, index) {
    return _c('el-option', {
      attrs: {
        "label": item.branchName,
        "value": index
      }
    }, [_vm._v(_vm._s(item.branchName))])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-table', {
    ref: "table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "element-loading-text": "拼命加载中",
      "data": _vm.pushData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "advertiseName",
      "label": "广告名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deviceId",
      "label": "设备名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "广告位置"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.pageType == 'index') ? _c('div', [_vm._v("首页")]) : _vm._e(), _vm._v(" "), (scope.row.pageType == 'indexAudio') ? _c('div', [_vm._v("首页音频")]) : _vm._e(), _vm._v(" "), (scope.row.pageType == 'listAudio') ? _c('div', [_vm._v("商品列表页音频")]) : _vm._e(), _vm._v(" "), (scope.row.pageType == 'detailAudio') ? _c('div', [_vm._v("商品详情页音频")]) : _vm._e(), _vm._v(" "), (scope.row.pageType == 'payAudio') ? _c('div', [_vm._v("购买页音频")]) : _vm._e(), _vm._v(" "), (scope.row.pageType == 'qrAudio') ? _c('div', [_vm._v("扫码购买音频")]) : _vm._e(), _vm._v(" "), (scope.row.pageType == 'deliveryAudio') ? _c('div', [_vm._v("提货页音频")]) : _vm._e(), _vm._v(" "), (scope.row.pageType == 'takeawayAudio') ? _c('div', [_vm._v("外卖提货页音频")]) : _vm._e(), _vm._v(" "), (scope.row.pageType == 'vendingAudio') ? _c('div', [_vm._v("出货中音频")]) : _vm._e(), _vm._v(" "), (scope.row.pageType == 'successAudio') ? _c('div', [_vm._v("完成页音频")]) : _vm._e(), _vm._v(" "), (scope.row.pageType == 'vendoverAudio') ? _c('div', [_vm._v("下件取货音频")]) : _vm._e(), _vm._v(" "), (scope.row.pageType == 'failAudio') ? _c('div', [_vm._v("出货异常页音频")]) : _vm._e(), _vm._v(" "), (scope.row.pageType == 'button') ? _c('div', [_vm._v("首页双按钮-左")]) : _vm._e(), _vm._v(" "), (scope.row.pageType == 'buttonRight') ? _c('div', [_vm._v("首页双按钮-右")]) : _vm._e(), _vm._v(" "), (scope.row.pageType == 'buttonMiddle') ? _c('div', [_vm._v("首页单按钮-居中")]) : _vm._e(), _vm._v(" "), (scope.row.pageType == 'excode') ? _c('div', [_vm._v("提货页")]) : _vm._e(), _vm._v(" "), (scope.row.pageType == 'shipment') ? _c('div', [_vm._v("出货页")]) : _vm._e(), _vm._v(" "), (scope.row.pageType == 'vend') ? _c('div', [_vm._v("完成页")]) : _vm._e(), _vm._v(" "), (scope.row.pageType == 'vendFail') ? _c('div', [_vm._v("出货异常页")]) : _vm._e(), _vm._v(" "), (scope.row.pageType == 'float') ? _c('div', [_vm._v("首页悬浮按钮")]) : _vm._e(), _vm._v(" "), (scope.row.pageType == 'ThirdUrl') ? _c('div', [_vm._v("第三方页面")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "fodderSize",
      "label": "素材大小"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "startTime",
      "label": "开始时间",
      "formatter": _vm.formatterstart
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "endTime",
      "label": "结束时间",
      "formatter": _vm.formatterend
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "255px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              _vm.pushEdit(scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              _vm.pushDelete(scope.row)
            }
          }
        }, [_vm._v("结束")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentpage,
      "page-count": _vm.pushpagesCount,
      "page-sizes": _vm.pagesizes,
      "page-size": _vm.pagesize,
      "total": _vm.pushpagesCount,
      "background": "",
      "layout": " total, prev, pager, next, jumper"
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-chahange": _vm.handleSizeChange
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-849c7604!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/market/AdvertiseManager.vue
// module id = 1083
// module chunks = 2